import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ILineItemDetail } from '../../shared/models';
import { CustomFormFieldService } from '../../shared/services/form-field.service';
import { AddVendorsComponent } from '../components/modals/add-vendors/add-vendors.component';
import { RunPpcComponent } from '../components/run-ppc/run-ppc.component';
import { UploadRCComponent } from '../components/upload-rc/upload-rc.component';
import { QES_DETAILS_FORMFIELDS } from '../constants/qes-details-fields.constant';
import { UpdateVendorEmailComponent } from '../components/modals/update-vendor-email/update-vendor-email.component';
import { MarketSearchComponent } from '../components/modals/market-search/market-search.component';
import { RfqAttachmentsComponent } from '../container/rfq-template/rfq-attachments/rfq-attachments.component';
import { NegotiationUpdateInfoComponent } from '../container/supplier-response-analysis/modals/negotiation-update-info/negotiation-update-info.component';
import { BuyerThresholdCheck, ILineItemMarketResult, ILineItemResultMap, INegotiationCreateRequest, IRFQSupplierQuotation, IRFQTemplateDetail, ISupplierMarketResult } from '../models';
import { AcceptCounterOfferComponent } from '../container/supplier-response-analysis/modals/accept-counter-offer/accept-counter-offer.component';
import { PoSuccessComponent } from '../container/supplier-response-analysis/modals/po-success/po-success.component';
import { QesUploadAttachmentComponent } from '../../shared/components/submit-qes/qes-upload-attachment/qes-upload-attachment.component';
import { SendVendorEmailComponent } from '../components/modals/send-vendor-email/send-vendor-email.component';
import { CreatePoModalComponent } from '../components/modals/create-po-modal/create-po-modal.component';
import { QesContainerComponent } from '../../shared/containers/qes-container/qes-container.component';
import { ViewPoApproverModalComponent } from '../components/approvals-po/view-po-approver-modal/view-po-approver-modal.component';
import { PoFailedModalComponent } from '../components/modals/po-failed-modal/po-failed-modal.component';
import { AutoPoModalComponent } from '../components/modals/auto-po-modal/auto-po-modal.component';
import { ViewPoHistoryComponent } from '../components/modals/view-po-history/view-po-history.component';
import { FilterReportColumnsComponent } from '../components/modals/filter-report-columns/filter-report-columns.component';
import { ViewRcImageComponent } from '../components/view-rc-image/view-rc-image.component';
import { EditDeadLineDatesPopupComponent } from '../container/edit-dead-line-dates-popup/edit-dead-line-dates-popup.component';
import { ManagerApproverPopupComponent } from '../components/modals/manager-approver-popup/manager-approver-popup.component';
import { EditEmailAddressComponent } from '../components/modals/edit-email-address/edit-email-address.component';
import { AcceptCounterOfferRemarksComponent } from '../container/supplier-response-analysis/modals/accept-counter-offer-remarks/accept-counter-offer-remarks.component';
import { DeligationComponent } from '../components/modals/deligation/deligation.component';
import { OpenOnboardModalComponent } from '../components/modals/open-onboard-modal/open-onboard-modal.component';
import { CreatePoLineitemModalComponent } from '../components/modals/create-po-lineitem-modal/create-po-lineitem-modal.component';
import { UpdatePOModalComponent } from '../components/modals/update-pomodal/update-pomodal.component';
import { AddUnRegisteredVendorsComponent } from '../components/modals/add-unRegisteredvendors/add-unRegisteredvendors.component';

@Injectable({
  providedIn: 'root'
})
export class PrBuyerHelperService {

  constructor(private _modalService: BsModalService,
    private _formFieldService : CustomFormFieldService,
    private _formBuilder : FormBuilder) { }

  public openUploadRCModal() {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Upload RC"
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(UploadRCComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openRCImage(imageUrl: string) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "View RC Image",
        imagePath: imageUrl
      },
      backdrop: 'static',
      class: 'modal-md'
    };
    const bsModalRef: BsModalRef = this._modalService.show(ViewRcImageComponent, initialState);
    return bsModalRef.content.onClose
  }


  public openRFQTemplateModal(rfqTemplateDetail : IRFQTemplateDetail) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Upload Attachment",
        rfqTemplateDetail
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(RfqAttachmentsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openuploadQESAttachmentModal(isPrAttachments?:boolean, prFilesList?:any,rfqFiles?:any) { //QES and PR attachments upload
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Upload Attachment",
        isPrAttachments: isPrAttachments ? isPrAttachments : false,
        prFilesList: prFilesList,
        rfqFileList: rfqFiles,
        viewRFQFiles: rfqFiles ? true : false
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(QesUploadAttachmentComponent, initialState);
    return bsModalRef.content.onClose;
  }

  public formatFileSize = (bytes : any, decimals = 2) : string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public getFilterParams<T>(rcFilters : T) : string {
    let query = "";
    Object.keys(rcFilters).forEach(element => {
      let value  = rcFilters ? rcFilters[element as keyof T] : null;
      query = query + `${element}=${value}&`
    });
    return query
  }

  public openNegotiationUpdateModal(negotiationRequest : INegotiationCreateRequest) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Negotiate with suppliers",
        negotiationRequest
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(NegotiationUpdateInfoComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openOfferAcceptanceModal(lineNumberQuotationMap : any, buyerThresholdCheck : BuyerThresholdCheck, prId : string | null) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Accept Counter Offer",
        lineNumberQuotationMap,
        buyerThresholdCheck,
        prId
      },
      backdrop: 'static',
      class : 'modal-lg'
    };
    const bsModalRef : BsModalRef = this._modalService.show(AcceptCounterOfferComponent, initialState);
    return bsModalRef.content.onClose
  }

  public poSuccessModal(lineNumberQuotationMap : Record<string, {rfq_supplier_quotation : IRFQSupplierQuotation}>, prId : number | undefined) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "PO Created Successfully",
        lineNumberQuotationMap,
        prId
      },
      backdrop: 'static',
      class : 'modal-lg'
    };
    const bsModalRef : BsModalRef = this._modalService.show(PoSuccessComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openRunPPCModal(lineItem: ILineItemDetail, prId: string) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Run PPC",
        prId: prId,
        line_item_number: lineItem.material_master
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(RunPpcComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openAddVendorModal(lineItem_list: any[], vendorList: any[], prID: any, addRFQVendor?:boolean|false) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Add vendor(s)",
        lineitem_list: lineItem_list,
        prID: prID,
        vendorList: vendorList,
        addRFQVendor:addRFQVendor
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(AddVendorsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openAddUnRegisterVendorModal(lineItem_list: any[], vendorList: any[], prID: any, addRFQVendor?:boolean|false) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Add vendor(s)",
        lineitem_list: lineItem_list,
        prID: prID,
        vendorList: vendorList,
        addRFQVendor:addRFQVendor
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(AddUnRegisteredVendorsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openMarketSearchModal(lineItemMarketResult: ILineItemMarketResult, lineItemDescription : string | undefined) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Market Search",
        lineItemMarketResult,
        lineItemDescription
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(MarketSearchComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openAddEmailModal(marketResults : ILineItemResultMap) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Update email(s)",
        marketResults
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(UpdateVendorEmailComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openEditEmailAddressModal(marketResults : any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Edit email(s)",
        marketResults
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(EditEmailAddressComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openAddEmailForVendorModal(prId: any, selectedVendor: any, lineItem_list: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Update email(s)",
        selectedVendor,
        lineItem_list,
        prId
      },
      backdrop: 'static',
      class : 'modal-md'
    };
    const bsModalRef : BsModalRef = this._modalService.show(SendVendorEmailComponent, initialState);
    return bsModalRef.content.onClose
  }

  public getvendorResultsColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      { headerName: 'vendor Code', field: 'VENDOR_CODE', resizable: true, filter: true ,pinned: 'left' },
      { headerName: 'Vendor Name', field: 'VENDOR_NAME', resizable: true, filter: true , pinned: 'left' },
      { headerName: 'Incoterms 1', field: 'INCOTERMS_1', resizable: true, filter: true },
      { headerName: 'Incoterms 2', field: 'INCOTERMS_2', resizable: true, filter: true },
      { headerName: 'Payment Key', field: 'TERMS_OF_PAYMENT_KEY', resizable: true, filter: true },
      { headerName: 'Sales person', field: 'RESPONSIBLE_SALESPERSON', resizable: true, filter: true },
      { headerName: 'vendor Email', field: 'EMAIL_ADDRESS', resizable: true, filter: true },
      { headerName: 'Trading Partner Number', field: 'TRADING_PARTNER', resizable: true, filter: true },
      { headerName: 'Partner Function', field: 'PARTNER_FUNCTION', resizable: true, filter: true },
    ];
    return coldefs;
  }

  public getQESDetailsForm() : FormGroup {
    return this._formFieldService.createFormGroup(QES_DETAILS_FORMFIELDS);
  }

  public checkVendorEmailPresence(lineItemsResultMap : ILineItemResultMap) : boolean {
    for (let index = 0; index < Object.keys(lineItemsResultMap).length; index++) {
      const materialMasterId = Object.keys(lineItemsResultMap)[index];
      if(materialMasterId && lineItemsResultMap[materialMasterId].supplierMarketResult?.length) {
        console.log("lineItemsResultMap[materialMasterId].supplierMarketResult",lineItemsResultMap[materialMasterId].supplierMarketResult[0]['EMAIL_ADDRESS'])
        const missingEmailVendors = lineItemsResultMap[materialMasterId].supplierMarketResult.filter((x: ISupplierMarketResult) => 
          !(x['EMAIL_ADDRESS'] && x['EMAIL_ADDRESS'] != null || x['R3_S_EMAIL_ADDRESS'] && x['R3_S_EMAIL_ADDRESS'] != null))
        if(missingEmailVendors.length) return true
      }
    }
    return false
  }
  
  public lineItemSpecificRFQQuotations(rfq_supplier_quotations : any[], lineItemNumber : string | number) : any[] {
    const data = rfq_supplier_quotations.filter((x)=>{
      x.quotation_details = x.quotation_details.filter((y:any) => {
        return y.line_item.every((z:any) => {
          return z.line_item_number == lineItemNumber
        })
      });
      return x
    });
    return data
  }

  public saveFileData = (function () {
    var a = document.createElement("a");
    document.body.appendChild(a);
    return function (data : any, fileName : any) {
      console.log(data)
      // var blob = new Blob([data], {type: "octet/stream"});
      var url = window.URL.createObjectURL(data);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    };
  }());

  public getLocalDateTime() : string
  {
    var d = new Date();
    const offset = d.getTimezoneOffset()/60
    var localTime = d.getTime();
    var localOffset = d.getTimezoneOffset() * 60000;
    // obtain UTC time in msec
    var utc = localTime + localOffset;
    // create new Date object for different city
    // using supplied offset
    var nd = new Date(utc - (3600000*offset));
    //nd = 3600000 + nd;
    utc = new Date(utc) as any;
    // return time as a string
    console.log(nd.toLocaleString());
    console.log(utc.toLocaleString());
    return nd.toLocaleString()
  }

  public openUpdatePOModal(selectedLineItems: any[], isSummary: boolean = false) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Confirm PO",
        selectedLineItems : selectedLineItems,
        isSummary: isSummary
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(UpdatePOModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openCreatePOModal(prData: any, qesData: any, vendorData? : any, isBelowThreshold?:boolean,hideTab?:any, ammendPo?:boolean, remarks?:string, totalPrice?:any) {
    console.log(isBelowThreshold, "isBelowThreshold")
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Edit approvers and PO fields",
        prData: prData,
        qesData: qesData,
        isBelowThreshold: isBelowThreshold,
        vendorData: vendorData,
        hideTab:hideTab,
        ammendPo:ammendPo,
        remarks:remarks,
        totalPrice:totalPrice
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(CreatePoModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openCreatePOLineItemModal(prData: any, qesData: any, vendorData? : any, isBelowThreshold?:boolean,hideTab?:any, ammendPo?:boolean) {
    console.log(isBelowThreshold, "isBelowThreshold")
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Edit approvers and PO fields",
        prData: prData,
        qesData: qesData,
        isBelowThreshold: isBelowThreshold,
        vendorData: vendorData,
        hideTab:hideTab,
        ammendPo:ammendPo
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(CreatePoLineitemModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openOnboard(rowData:any){
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Onboard Unregistered Vendor",
        prData: rowData
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(OpenOnboardModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openDeligationModal(prData: any){
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Enter Email Id",
        prData: prData
      },
      backdrop: 'static'
    };
    const bsModalRef : BsModalRef = this._modalService.show(DeligationComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openManagerApprovalModal(isRFQSENT?:boolean, vendorName?:any,rankCheck?:boolean,rank?:any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: isRFQSENT?"RFQ Sent Successfully":rankCheck?'Check the Selected Vendor Rank':"Factory Procurement Approvel Required",
        isRFQSENT,
        vendorName,
        rankCheck
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(ManagerApproverPopupComponent, initialState);
    return bsModalRef.content.onClose
  }


  public openPOHistoryModal(po_number:string,line_item_number:string){
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "PO History",
        po_number:po_number,
        line_item_no:line_item_number

      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(ViewPoHistoryComponent, initialState);
    return bsModalRef.content.onClose
  }

  public successPOCreationModal(success: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "PO Creation Result",
        success: success
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(PoFailedModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public successErrorPOCreationModal(successError: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "PO Creation Result",
        successError: successError
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(PoFailedModalComponent, initialState);
    return bsModalRef.content.onClose
  }


  public failedPOCreationModal(error: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "PO Creation Result",
        error: error
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(PoFailedModalComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openViewPOApproversModal(po_number: string) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "View approver status",
        po_number: po_number
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(ViewPoApproverModalComponent, initialState);
    return 
  }

  public captureTaxcode(prId: string, vendor_details?:any[]) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Create PO",
        prId: prId,
        vendor_details:vendor_details
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(AutoPoModalComponent, initialState);
    return 
  }

  public getPoHistoryColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      { headerName: 'PO History Category', field: 'PO_HISTORY_CATEGORY', resizable: true, filter: true, pinned: 'left', cellRenderer: (data: any) => {
        if (data.value == 'E') {
          return "E - GOODS REICEIPT"
        } else if (data.value == 'Q') {
          return 'Q - INVOICE REICEIPT'
        } else if (data.value == 'SEnt') {
          return "SEnt - Service entry"
        } else {
          return data.value
        }
      } },
      { headerName: 'PO Number', field: 'PO_DOC_NO', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'PO Line Item', field: 'PO_LINE_ITEM', resizable: true, filter: true },
      { headerName: 'Material Number', field: 'MATERIAL_NUMBER', resizable: true, filter: true },
      { headerName: 'Material Doc Number', field: 'MATERIAL_DOC_NUMBER', resizable: true, filter: true },
      { headerName: 'Material Doc Item', field: 'MATERIAL_DOC_ITEM', resizable: true, filter: true },
      { headerName: 'Movement Type', field: 'MOVEMENT_TYPE', resizable: true, filter: true },
      { headerName: 'Quantity', field: 'QUANTITY', resizable: true, filter: true },
      { headerName: 'Document Year', field: 'DOCUMENT_YEAR', resizable: true, filter: true },
      { headerName: 'Reference Doc Number', field: 'REFERENCE_DOC_NUMBER', resizable: true, filter: true }
    ];
    return coldefs;
  }

  public openFilterColumnsForReport(allReportColumns:any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Filter Reports Columns",
        allReportColumns: allReportColumns
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(FilterReportColumnsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openEditDeadlineModal(prId:any,tempId:any, qt_deadline:any,deliveryDeadline:any) { //QES and PR attachments upload
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Upload Attachment",
        prId: prId,
        qt_deadline: qt_deadline,
        tempId:tempId,
        deliveryDeadline: deliveryDeadline
      },
      backdrop: 'static',
      class : 'modal-lg'
    };
    const bsModalRef : BsModalRef = this._modalService.show(EditDeadLineDatesPopupComponent, initialState);
    return bsModalRef.content.onClose;
  }

  public acceptCounterOfferRemarks() : any {
      const initialState: ModalOptions<any> = {
        initialState: {
        class: 'modal-dialogue-centered modal-lg',
        backdrop: 'static',
        keyboard: true
        }
      };
      const bsModalRef = this._modalService.show(AcceptCounterOfferRemarksComponent,initialState);
      
    return bsModalRef.content.onClose;
  }
  
}
